<template>
  <div>
    <div
      class="container mx-auto flex flex-col items-center space-y-5 md:space-y-0 md:flex-row my-20 md:space-x-10"
    >
      <div class="w-full md:w-1/2">
        <div class="flex flex-row items-center space-x-4 mb-10">
          <div
            class="bg-gradient-to-r from-Terracotta to-Cashmere w-10 h-3.5"
          ></div>
          <h3 class="text-md md:text-lg font-medium tracking-[3px]">
            FRONT OFFICE SOLUTIONS
          </h3>
        </div>
        <div class="block md:hidden mb-4">
          <img
            src="../assets/images/solution-view-header-img.png"
            class="object-cover"
            alt=""
          />
        </div>
        <p class="font-bold text-2xl md:text-4xl md:leading-[3rem] mb-16">
          "It’s all about putting the best team together – not just in the core
          business activities, but also in the
          <span class="text-Terracotta italic">“Non-Core” processes"</span>
        </p>
        <p class="text-xl max-w-lg mb-4 md:mb-10">
          We make your non-core tasks our core task keeping your business
          process functioning at a 100.
        </p>
        <div class="flex flex-row items-center space-x-4">
          <GetAQuoteButton text="GET A QUOTE" color="#d1643a" />
          <BookACallButton />
        </div>
      </div>
      <div class="w-full md:w-1/2">
        <div class="hidden md:block">
          <img
            src="../assets/images/solution-view-header-img.png"
            class="object-cover"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetAQuoteButton from "@/components/GetAQuoteButton.vue";
import BookACallButton from "@/components/BookACallButton.vue";
export default {
  name: "SolutionViewHeader",
  components: {
    GetAQuoteButton,
    BookACallButton,
  },
};
</script>
